import * as React from "react";

// style, design
import CancelLeaseContractForm from "../../components/Forms/LeaseContract/CancelForm/FlowForm";

export default () => {
  return <CancelLeaseContractForm />;
};
